import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

const path = '/NivelEnseñanza'

export default {
  cambiar(obj) {
    console.log("cambiar");
    return axios.post(`${api.url + path}/Cambiar`, obj)

  },
  crear(obj) {
    console.log("crear");
    return axios.post(`${api.url + path}/Crear`, obj)

  },

  eliminar(obj) {
    console.log("eliminar");
    return axios.post(`${api.url + path}/Eliminar`, obj)

  },

  gets() {
    console.log();
  },

  find(obj) {
    console.log("find");
    return axios.post(`${api.url + path}/Eliminar`, obj)


  },

  getFormData(id) {
    console.log("getFormData");
    return axios.get(`${api.url + path}/GetFormData`,{
      params: {
        'listParams.id': id,
        }
    })
  },
  getLista(obj) {
    return axios.get(`${api.url + path}/GetLista`, { params: obj });
  },
  getEstablecimientos() {
      // unidadadministrativa_id/unidadeducativa_id/nivelenseñanza_id en 0 a
      // propósito: esta lista alimenta el combo "Establecimiento" (buscar
      // entre TODAS las instituciones), no debe quedar acotada a la unidad
      // administrativa del establecimiento con el que estás logueado.
      return axios.get(`${api.url + path}/GetLista`, {
        params: {
          limit: 500,
          unidadadministrativa_id: 0,
          unidadeducativa_id: 0,
          nivelenseñanza_id: 0
        }
      });
  }
  // getLista(obj) {
  //   console.log("getLista");
  //   return axios.get(`${api.url + path}/GetLista`,{
  //     params: {
  //       'listParams.unidadEducativa_Id': obj.unidadEducativa_Id,
  //       }
  //   })
  // },
}



// WEBPACK FOOTER //
// ./src/services/nivelensenianza/index.js